/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M20.074 47.99c1.707-1.032 4.164-.56 5.594 1.074L36.009 60.53c.283.313.73.419 1.121.264a1.02 1.02 0 00.644-.96l-.434-41.087c-.027-2.566 2.027-4.675 4.578-4.703 2.55-.027 4.648 2.038 4.675 4.604l.228 21.728.095 9.017a1.017 1.017 0 001.024 1.009 1.017 1.017 0 001.003-1.03l-.095-9.016-.228-21.729-.062-5.924C48.53 10.137 50.585 8.028 53.136 8c2.551-.027 4.648 2.038 4.675 4.604l.056 5.255.111 10.567.218 20.847a1.017 1.017 0 001.025 1.009 1.017 1.017 0 001.003-1.03l-.219-20.847-.111-10.567c-.027-2.566 2.026-4.675 4.577-4.702 2.551-.028 4.648 2.038 4.675 4.604l.126 11.893.057 5.497.147 14.023a1.017 1.017 0 001.024 1.01 1.017 1.017 0 001.003-1.03l-.147-14.024-.057-5.497c-.027-2.566 2.026-4.675 4.577-4.703 2.551-.027 4.648 2.039 4.675 4.604l.344 32.717.105 9.9c.111 10.598-8.13 19.64-17.994 19.744L51.308 92c-5.892.063-12.654-3.535-16.1-8.56L18.457 53.624c-1.006-2.005-.299-4.477 1.617-5.634z"
    ></path>
  </Svg>
)

export default Icon
